import { z } from 'zod';

export const invitationTokenSchema = z.string().regex(/^[0-9a-f]{64}$/);

export interface OrganizationInvitation {
  invitationId: string;
  organizationId: string;
  email: string;
  permissionSetId: string;
  expiresAtMs: number;
  availableLoginMethods: Array<'PASSWORD_SETUP' | 'PASSWORD' | 'GOOGLE' | 'MICROSOFT'>;
}

export interface InvitationPasswordReceipt {
  status: 'SENT' | 'PENDING';
  message?: string;
}
